<template>
  <div class="header min-width">
    <div class="btn-box" v-if="!userInfo.name" @click="handleGoLogin">
      <div>登录</div>
      <div>注册</div>
    </div>
    <div class="user-box" v-else>
      <div class="user" @click="handleJump">
        <span>欢迎，</span>
        <img class="avatar" size="medium" fit="none" :src="userInfo.iconUrl ? fileUrl + userInfo.iconUrl : 'https://cube.elemecdn.com/3/7c/3ea6beec64369c2642b92c6726f1epng.png'" />
        <span>{{userInfo.name}}</span>
      </div>
      <i class="logout-icon" @click="handleLogout"></i>
    </div>
    <div class="content">
      <img class="logo" src="~@/assets/images/home_logo.png" alt="">
      <div class="search-box">
        <div class="top">
          <div class="input">
            <div class="select" @click="handleSelect" ref="select">
              <span>{{optionList[selectedOpt].text}}</span>
              <i class="arrow-icon"></i>
            </div>
            <transition name="options">
              <div class="options" v-if="isShow">
                <div class="option-item" :style="optionItemStyle" v-for="item in optionList" :key="item.searchType" @click="handleChange(item)">{{item.text}}</div>
              </div>
            </transition>
            <el-input v-model="searchWord"></el-input>
            <i class="search-icon" @click="handleJumpSearchResult()"></i>
          </div>
          <div class="search-text" @click="handleJumpSearch">高级搜索</div>
        </div>
        <div class="hot-search">
          <span>热搜：</span>
          <span class="hot-item" v-for="item in rendingSearchList" :key="item.id" @click="handleJumpSearchResult(item.searchname)">{{item.searchname}}</span>
        </div>
      </div>
    </div>
    <div class="bar">
      <div class="bar-item" :class="{'active': menuIndex == index}" v-for="(item, index) in tabList" :key="item.id" @click="handleBarClick(index)">{{item.name}}</div>
    </div>
  </div>
</template>
<script>
  import { mapState } from 'vuex'
  import { getReligionMenu, logout, getRendingSearch, fileUrl } from '@/api/urls'
  export default {
    data() {
      return {
        fileUrl: fileUrl,
        searchWord: sessionStorage.getItem('topSearchWord') ? JSON.parse(sessionStorage.getItem('topSearchWord'))[0].searchVal : '',
        isShow: false,
        tabList: [],
        optionList: [
          { id: 0, searchKey: 'title', text: '标题' },
          { id: 1, searchKey: 'author', text: '作者' },
          { id: 2, searchKey: 'digest', text: '摘要' },
          { id: 3, searchKey: 'keyWord', text: '关键词'}
        ],
        selectedOpt: 0,
        optionItemStyle: {
          width: '90px'
        },
        rendingSearchList: []
      }
    },
    watch: {
      isShow(nv, ov) {
        if(nv) {
          this.optionItemStyle.width = this.$refs.select.offsetWidth + 'px'
        }
      },
      $route: function(nv, ov) {
        if(nv.name == 'searchResult') {
          this.$bus.$on('clearSearch', () => {
            this.searchWord = ''
          })
        }
        if(ov.name == 'searchResult') {
          this.$bus.$off('clearSearch', () => {
            this.searchWord = ''
          })
        }
      }
    },
    computed: {
      ...mapState({
        menuIndex: state => state.menuIndex,
        userInfo: state => state.userInfo
      }),
      isActive() {
        return this.$route.name == 'home' || this.$route.name == 'religionDetail'
      }
    },
    beforeDestroy() {
      document.removeEventListener('click', (e) => {
        const el = this.$refs.select
        if(el) {
          if(!el.contains(e.target)) {
            this.isShow = false;
          }
        }
      })
      window.removeEventListener('popstate', this.onPopState);
    },
    mounted() {
      // 添加 popstate 事件监听
      window.history.pushState(null, null, window.location.href);
	    window.addEventListener('popstate', this.onPopState);
      this.getMenuList();
      this.getRendingSearch()
      document.addEventListener('click', (e) => {
        const el = this.$refs.select
        if(el) {
          if(!el.contains(e.target)) {
            this.isShow = false;
          }
        }
      })
    },
    methods: {
      getRendingSearch() {
        getRendingSearch().then(res => {
          let arr = res
          if(arr.length > 5) {
            arr.splice(5)
          }
          this.rendingSearchList = arr
        }).catch(err => {
          console.log(err)
        })
      },
      handleGoLogin() {
        this.$router.push('/login')
      },
      handleLogout() {
        this.$confirm('确定退出登录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'info',
          lockScroll: false
        }).then(() => {
          logout().then(res => {
            this.$store.dispatch('logout')
          })
        }).catch(() => {})
      },
      onPopState() {
        if(this.$route.name == 'home') {
          this.$store.commit('UPDATE_MENUINDEX', 0)
        }
        else if (this.$route.name  == 'religionDetail') {
          this.$store.commit('UPDATE_MENUINDEX', 1)
        }
      },
      getMenuList() {
        getReligionMenu()
          .then(res => {
            res.unshift({
              id: 0,
              name: '首页'
            })
            this.tabList = res
          })
          .catch(err => {
            console.log(err)
          })
      },
      handleSelect() {
        this.isShow = !this.isShow
      },
      handleChange(item) {
        this.selectedOpt = item.id
        this.isShow = false
      },
      handleBarClick(index) {
        this.$store.commit('UPDATE_MENUINDEX', index)
        if(index == 0) {
          this.$router.push({
            name: 'home'
          })
          return
        }
        this.$router.push({
          name: 'religionDetail'
        })
      },
      handleJump() {
        this.$router.push({
          name: 'accountInformation'
        })
      },
      handleJumpSearch() {
        this.$router.push({
          name: 'search'
        })
      },
      handleJumpSearchResult(searchWord) {
        if(!searchWord && !this.searchWord) {
          return
        }
        if(searchWord) this.searchWord = searchWord
        
        const query = [{
                        searchKey: this.optionList[this.selectedOpt].searchKey, 
                        searchVal: this.searchWord,
                        searchType: 0
                      }]
                    
        sessionStorage.setItem('topSearchWord', JSON.stringify(query))
        if(this.$route.name != 'searchResult') {
          this.$router.push({
            name: 'searchResult',
            query: {
              searchOptions: JSON.stringify(query)
            }
          })
        }else {
          this.$bus.$emit('topSearch', query)
        }
        
      }
    }
  }
</script>
<style lang="scss" scoped>
  .header {
    position: absolute;
    top: 0;
    left: 50%;
    margin-left: -640px;
    background: transparent !important;
    .btn-box {
      display: flex;
      justify-content: flex-end;
      font-size: 16px;
      font-family: Source Han Sans CN;
      font-weight: 500;
      color: #FFFFFF;
      opacity: 0.5;
      padding: 19px 0 35px;
      div {
        border-right: 2px solid #fff;
        cursor: pointer;
        &:first-child {
          padding-right: 20px; 
        }
        &:last-child {
          border: none;
          padding-left: 20px; 
        }
      }
    }
    .user-box {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      height: 36px;
      margin: 16px 0 24px;
      font-size: 16px;
      .user {
        display: flex;
        align-items: center;
        font-weight: 500;
        color: #a5b2d9;
        cursor: pointer;
        .avatar {
          width: 36px;
          height: 36px;
          border-radius: 25px;
          margin-right: 5px;
          /* object-fit: cover; */
        }
      }
      .logout-icon {
        width: 17px;
        height: 17px;
        background: url('~@/assets/images/logout_icon.png') no-repeat 0 0;
        background-size: 100% 100%;
        cursor: pointer;
        margin-left: 27px;
      }
    }
    .content {
      display: flex;
      justify-content: space-between;
      .logo {
        /* width: 514px; */
        height: 42px;
      }
      .search-box {
        .top {
          display: flex;
          align-items: center;
          position: relative;
          .input {
            width: 445px;
            height: 40px;
            background: #fff;
            display: flex;
            align-items: center;
            padding: 4px 15px 4px 0;
            box-sizing: border-box;
            margin-right: 17px;
            .select {
              height: 100%;
              padding: 0 13px 0 22px;
              display: flex;
              align-items: center;
              /* justify-content: center; */
              box-sizing: border-box;
              border-right: 1px solid #DCD4D4;
              cursor: pointer;
              span {
                font-size: 16px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #666666;
              }
              .arrow-icon {
                display: inline-block;
                width: 10px;
                height: 5px;
                background: url('~@/assets/images/arrow_down.png') no-repeat 0 0;
                background-size: 100% 100%;
                margin-left: 12px;
              }
            }
            .options-enter, .options-leave-to {
              opacity: 0;
              transform: scaleY(0.9);
              transform-origin: top center;
            }
            .options-enter-to, .options-leave {
              opacity: 1;
              transform: scaleY(1);
              transform-origin: top center;
            }
            .options-enter-active, .options-leave-active {
              transition: all .2s ease-in-out;
            }
            .options {
              position: absolute;
              top: 40px;
              left: 0;
              background: #fff;
              z-index: 10;
              .option-item {
                height: 39px;
                line-height: 39px;
                text-align: center;
                font-size: 16px;
                color: #666666;
                font-family: Source Han Sans CN;
                font-weight: 500;
                cursor: pointer;
                &:hover {
                  color: #fff;
                  background: #5E94F1;
                }
              }
            }
            ::v-deep .el-input {
              flex: 1;
            }
            ::v-deep .el-input__inner {
              border: none;
            }
            .search-icon {
              display: inline-block;
              width: 16px;
              height: 17px;
              background: url('~@/assets/images/search_icon.png') no-repeat 0 0;
              background-size: 100% 100%;
              cursor: pointer;
            }
          }
          .search-text {
            font-size: 18px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #FFFFFF;
            cursor: pointer;
          }
        }
        .hot-search {
          width: 445px;
          padding: 10px 20px;
          font-size: 16px;
          font-family: Source Han Sans CN;
          font-weight: 500;
          color: #C9DDFF;
          letter-spacing: 1px;
          .hot-item {
            margin-right: 25px;
            cursor: pointer;
          }
        }
      }
    }
    .bar {
      display: flex;
      justify-content: space-between;
      padding: 30px 40px 0;
      .bar-item {
        font-size: 22px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #FFFFFF;
        padding: 0 5px 15px;
        letter-spacing: 1px;
        cursor: pointer;
      }
      .active {
        border-bottom: 3px solid #11EFF2;
      }
    }
  }
</style>